import { createContext } from "react";

export const StepOrderPausePlayAcceptedContext = createContext<
  (orderIds: number[], acceptedAt: number, isDelete?: boolean) => void
>(() => {});
